<template>
  <div class="auth-page">
    <!-- 返回按钮 -->
    <button class="back-btn" @click="goBack">
      <i class="fas fa-arrow-left"></i>
    </button>
    <div class="auth-container">
      <!-- 登录表单区域 -->
      <div 
        class="form-panel login-panel"
        :class="{ 'form-left': isLogin, 'form-right': !isLogin }"
      >
        <div class="form-content">
          <h2 class="form-title">欢迎回来</h2>
          <p class="form-subtitle">登录到您的账户！喵喵喵！</p>
          
          <form class="auth-form" @submit.prevent="handleLogin">
            <div class="form-group">
              <input
                v-model="loginForm.usernameEmail"
                type="email"
                placeholder="请输入邮箱"
                required
              >
            </div>

            <div class="form-group">
              <input
                v-model="loginForm.password"
                :type="showLoginPassword ? 'text' : 'password'"
                placeholder="请输入您的密码"
                required
              >
              <button
                type="button"
                class="password-toggle"
                @click="showLoginPassword = !showLoginPassword"
              >
                <i :class="showLoginPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>

            <button type="submit" class="submit-btn" :disabled="isLoading">
              <span v-if="!isLoading">登 录</span>
              <div v-else class="loading-spinner"></div>
            </button>

            <p v-if="loginError" class="error-message">{{ loginError }}</p>
          </form>
        </div>
      </div>

      <!-- 注册表单区域 -->
      <div 
        class="form-panel register-panel"
        :class="{ 'form-left': !isLogin, 'form-right': isLogin }"
      >
        <div class="form-content">
          <h2 class="form-title">创建账号</h2>
          <p class="form-subtitle">请注册账号！喵喵喵！</p>
          
          <form class="auth-form" @submit.prevent="handleRegister">
            <div class="form-group">
              <input
                v-model="registerForm.username"
                type="text"
                placeholder="请输入用户名"
                required
              >
            </div>

            <div class="form-group">
              <input
                v-model="registerForm.email"
                type="email"
                placeholder="请输入您的邮箱"
                required
              >
            </div>

            <div class="form-group code-group">
              <input
                v-model="registerForm.code"
                type="text"
                placeholder="请输入验证码"
                required
                :disabled="!isCodeSent"
              >
              <button
                type="button"
                class="send-code-btn"
                @click="handleSendCode"
                :disabled="isLoading || isCountingDown"
              >
                <span v-if="!isCountingDown">获取验证码</span>
                <span v-else>{{ countdown }}s</span>
              </button>
            </div>

            <p v-if="registerSuccess" class="success-message">{{ registerSuccess }}</p>
            <p v-if="registerError" class="error-message">{{ registerError }}</p>

            <div class="form-group">
              <input
                v-model="registerForm.password"
                :type="showRegisterPassword ? 'text' : 'password'"
                placeholder="请输入密码（至少8位）"
                required
                minlength="8"
              >
              <button
                type="button"
                class="password-toggle"
                @click="showRegisterPassword = !showRegisterPassword"
              >
                <i :class="showRegisterPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>

            <div class="form-group">
              <input
                v-model="registerForm.confirmPassword"
                :type="showConfirmPassword ? 'text' : 'password'"
                placeholder="请再次输入密码"
                required
              >
              <button
                type="button"
                class="password-toggle"
                @click="showConfirmPassword = !showConfirmPassword"
              >
                <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>

            <button 
              type="submit" 
              class="submit-btn" 
              :disabled="isLoading || !isFormValid"
            >
              <span v-if="!isLoading">注 册</span>
              <div v-else class="loading-spinner"></div>
            </button>
          </form>
        </div>
      </div>

      <!-- 蓝色/紫色可移动卡片 -->
      <div 
        class="overlay-card"
        :class="{ 'active': !isLogin }"
      >
        <div class="overlay-content">
          <img src="@/assets/img/网站logo.png" alt="林影心语" class="overlay-logo">
          <h2 class="overlay-title">{{ isLogin ? '创建账号' : '登入账号' }}</h2>
          <p class="overlay-subtitle">{{ isLogin ? '什么？你还没有账号？快去注册吧' : '已经有账号了，登入账号' }}</p>
          <button 
            class="overlay-btn"
            @click="toggleAuthMode"
            :disabled="isLoading"
          >
            {{ isLogin ? '注册账号' : '立即登录' }}
          </button>
        </div>
      </div>
    </div>

    <div class="background-decoration">
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
        <div class="shape shape-5"></div>
        <div class="shape shape-6"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const API_BASE_URL = 'https://api.banana404.top'

export default {
  name: 'AuthPage',
  setup() {
    const router = useRouter()
    let countdownTimer = null
    const isLogin = ref(true)
    const isLoading = ref(false)
    const showLoginPassword = ref(false)
    const showRegisterPassword = ref(false)
    const showConfirmPassword = ref(false)
    const loginError = ref('')
    const registerError = ref('')
    const registerSuccess = ref('')
    const codeSalt = ref('')
    const isCodeSent = ref(false)
    const isCountingDown = ref(false)
    const countdown = ref(60)

    const loginForm = ref({
      usernameEmail: '',
      password: ''
    })

    const registerForm = ref({
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      code: ''
    })

    onMounted(() => {
      const shapes = document.querySelectorAll('.shape')
      
      shapes.forEach((shape, index) => {
        setTimeout(() => {
          shape.classList.add('animate')
        }, 300 + index * 150)
      })
    })

    onUnmounted(() => {
      if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
      }
    })

    const passwordMismatch = computed(() => {
      return registerForm.value.password && 
             registerForm.value.confirmPassword && 
             registerForm.value.password !== registerForm.value.confirmPassword
    })

    const isFormValid = computed(() => {
      return registerForm.value.username &&
             registerForm.value.email &&
             registerForm.value.password &&
             registerForm.value.confirmPassword &&
             registerForm.value.code &&
             codeSalt.value &&
             !passwordMismatch.value
    })

    const toggleAuthMode = () => {
      if (isLoading.value) return
      isLogin.value = !isLogin.value
      loginError.value = ''
      registerError.value = ''
      registerSuccess.value = ''
      
      if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
      }
      isCountingDown.value = false
      countdown.value = 60
      isCodeSent.value = false
      codeSalt.value = ''
    }
    
    // 返回上一页功能
    const goBack = () => {
      router.back()
    }

    const startCountdown = () => {
      isCountingDown.value = true
      countdown.value = 60
      
      if (countdownTimer) {
        clearInterval(countdownTimer)
      }
      
      countdownTimer = setInterval(() => {
        countdown.value--
        if (countdown.value <= 0) {
          clearInterval(countdownTimer)
          countdownTimer = null
          isCountingDown.value = false
        }
      }, 1000)
    }

    const handleSendCode = async () => {
      if (!registerForm.value.email) {
        registerError.value = '请输入邮箱地址'
        return
      }

      isLoading.value = true
      registerError.value = ''

      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/user/email/code/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({
            email: registerForm.value.email
          })
        })

        const data = await response.json()

        if (data.code === 200) {
          codeSalt.value = data.data?.codeSalt || ''
          isCodeSent.value = true
          registerSuccess.value = '验证码已发送，请查收邮箱'
          startCountdown()
        } else {
          registerError.value = data.msg || '发送验证码失败'
        }
      } catch (error) {
        console.error('发送验证码错误:', error)
        registerError.value = '网络错误，请稍后重试'
      } finally {
        isLoading.value = false
      }
    }

    const handleLogin = async () => {
      if (!loginForm.value.usernameEmail || !loginForm.value.password || isLoading.value) return
      
      isLoading.value = true
      loginError.value = ''
      
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/user/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({
            email: loginForm.value.usernameEmail,
            passwd: loginForm.value.password
          })
        })

        const data = await response.json()

        if (data.code === 200) {
          localStorage.setItem('realUserInfo', JSON.stringify(data.data))
          
          // 设置跨子域 Cookie
          const domain = '.hkmre.top'; // 主域名，前面加 dot 表示所有子域名都能访问
          const expires = new Date();
          expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7天过期
          
          // 从响应中获取认证信息，根据后端实际返回结构调整
          // 注意：实际项目中，认证信息可能在 cookie 中由后端设置
          // 这里我们手动设置一个跨域 cookie 用于子域名访问
          const userData = data.data || {};
          
          // 使用与后端一致的 cookie 名称
          document.cookie = `forestwhisper=${JSON.stringify(userData)}; path=/; domain=${domain}; expires=${expires.toUTCString()}; secure; sameSite=none`;
          
          router.push('/user-panel')
        } else {
          loginError.value = data.msg || '登录失败，请检查邮箱和密码'
        }
      } catch (error) {
        console.error('登录错误:', error)
        loginError.value = '网络错误，请检查网络连接'
      } finally {
        isLoading.value = false
      }
    }

    const handleRegister = async () => {
      if (!isFormValid.value || isLoading.value) return
      
      isLoading.value = true
      registerError.value = ''
      registerSuccess.value = ''
      
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/user/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({
            email: registerForm.value.email,
            username: registerForm.value.username,
            passwd: registerForm.value.password,
            code: registerForm.value.code
          })
        })

        const data = await response.json()

        if (data.code === 200) {
          registerSuccess.value = '注册成功！正在跳转到登录...'
          setTimeout(() => {
            isLogin.value = true
            loginForm.value.usernameEmail = registerForm.value.email
            registerForm.value = {
              username: '',
              email: '',
              password: '',
              confirmPassword: '',
              code: ''
            }
            codeSalt.value = ''
            isCodeSent.value = false
            registerSuccess.value = ''
          }, 2000)
        } else {
          registerError.value = data.msg || '注册失败，请检查输入信息'
        }
      } catch (error) {
        console.error('注册错误:', error)
        registerError.value = '网络错误，请稍后重试'
      } finally {
        isLoading.value = false
      }
    }

    return {
      isLogin,
      isLoading,
      showLoginPassword,
      showRegisterPassword,
      showConfirmPassword,
      loginForm,
      registerForm,
      passwordMismatch,
      isFormValid,
      loginError,
      registerError,
      registerSuccess,
      codeSalt,
      isCodeSent,
      isCountingDown,
      countdown,
      toggleAuthMode,
      handleLogin,
      handleRegister,
      handleSendCode,
      goBack
    }
  }
}
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.auth-page {
  min-height: 100vh;
  background: var(--background-color);
  font-family: 'YouSheShaYuFeiTe', Arial, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.auth-container {
  position: relative;
  width: 900px;
  height: 550px;
  background: white;
  border-radius: 30px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.form-panel {
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  padding: 50px 40px;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  background: white;
}

.login-panel {
  left: 0;
  transform: translateX(0);
}

.login-panel.form-right {
  transform: translateX(100%);
}

.register-panel {
  right: 0;
  transform: translateX(100%);
}

.register-panel.form-left {
  transform: translateX(0);
}

.form-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.form-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin-bottom: 8px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: 0.1s;
}

.form-subtitle {
  color: #888;
  text-align: center;
  font-size: 14px;
  margin-bottom: 35px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: 0.2s;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.auth-form {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-group {
  position: relative;
  margin-bottom: 10px;
  opacity: 0;
  transform: translateX(-20px);
  animation: slideInRight 0.5s ease forwards;
}

.form-group:nth-child(1) { animation-delay: 0.2s; }
.form-group:nth-child(2) { animation-delay: 0.3s; }
.form-group:nth-child(3) { animation-delay: 0.4s; }
.form-group:nth-child(4) { animation-delay: 0.5s; }

@keyframes slideInRight {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.form-group input {
  width: 100%;
  padding: 14px 45px 14px 18px;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  font-size: 14px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #f8f8f8;
  position: relative;
  overflow: hidden;
}

.form-group input::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  transition: width 0.3s ease;
}

.form-group input:focus::before {
  width: 100%;
}

.form-group input:focus {
  outline: none;
  border-color: var(--primary-color);
  background: white;
  box-shadow: 0 4px 15px rgba(43, 113, 234, 0.15);
  transform: translateY(-2px);
}

.form-group input:focus + .password-toggle {
  color: var(--primary-color);
  transform: translateY(-50%) scale(1.1);
}

.form-group input:not(:focus) {
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.03);
}

.form-group input::placeholder {
  color: #bbb;
  transition: all 0.3s ease;
}

.form-group input:focus::placeholder {
  opacity: 0.6;
  transform: translateX(5px);
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 15px;
  padding: 5px;
  transition: all 0.3s ease;
}

.password-toggle:hover {
  color: var(--primary-color);
  transform: translateY(-50%) scale(1.1);
}

.code-group {
  display: flex;
  gap: 10px;
}

.code-group input {
  flex: 1;
}

.send-code-btn {
  padding: 12px 16px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.send-code-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(43, 113, 234, 0.4);
}

.send-code-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.error-message {
  color: var(--primary-color);
  font-size: 13px;
  margin-bottom: 15px;
  text-align: center;
  animation: shake 0.5s ease;
}

.success-message {
  color: var(--success-color);
  font-size: 13px;
  margin-bottom: 15px;
  text-align: center;
  animation: fadeInUp 0.3s ease;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-5px); }
  40%, 80% { transform: translateX(5px); }
}

.submit-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: auto;
  background: var(--primary-color);
  color: white;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: 0.6s;
}

.submit-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.submit-btn:hover:not(:disabled)::before {
  left: 100%;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(43, 113, 234, 0.4);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(43, 113, 234, 0.3);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  to { 
    transform: rotate(360deg); 
  }
}

.overlay-card {
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;
  overflow: hidden;
  right: 0;
  box-shadow: 0px 0px 35px #333333c4;
  transform: translateX(0);
  background: linear-gradient(135deg, #a8d8ff 0%, #7ec8ff 50%, #5bb8ff 100%);
  border-radius: 30px 0 0 30px;
}

.overlay-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: rotate 20s linear infinite;
}

.overlay-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  animation: shimmer 3s ease-in-out infinite;
  
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes shimmer {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

.overlay-card.active {
  transform: translateX(-100%);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 0 30px 30px 0;
  box-shadow: 0px 0px 35px #333333c4;
}

.overlay-content {
  text-align: center;
  padding: 20px;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
}

.overlay-card:hover .overlay-content {
  transform: scale(1.05);
}

.overlay-logo {
  width: 90px;
  height: 90px;
  border-radius: 20px;
  object-fit: cover;
  margin-bottom: 25px;
  transition: all 0.4s ease;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.overlay-card:hover .overlay-logo {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
}

.overlay-title {
  font-size: 26px;
  font-weight: 700;
  color: white;
  margin-bottom: 10px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: 0.3s;
}

.overlay-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  margin-bottom: 30px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: 0.5s;
}

.overlay-btn {
  padding: 12px 35px;
  border: 2px solid white;
  border-radius: 25px;
  background: transparent;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: 0.7s;
}

.overlay-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.overlay-btn:hover:not(:disabled)::before {
  left: 100%;
}

.overlay-btn:hover:not(:disabled) {
  background: white;
  color: #764ba2;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  transform: translateY(-3px);
}

.overlay-btn:active:not(:disabled) {
  transform: translateY(-1px);
}

.overlay-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
}

.floating-shapes {
  position: relative;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgb(132 234 189 / 36%);
  opacity: 0;
  transition: all 0.8s ease;
}

.shape.animate {
  opacity: 1;
}

.shape-1 {
  width: 400px;
  height: 400px;
  top: -150px;
  left: -150px;
}

.shape-2 {
  width: 300px;
  height: 300px;
  top: 50%;
  right: -100px;
  transform: translateY(-50%);
}

.shape-3 {
  width: 200px;
  height: 200px;
  bottom: -50px;
  left: 20%;
}

.shape-4 {
  width: 150px;
  height: 150px;
  bottom: 100px;
  right: -30px;
}

.shape-5 {
  width: 100px;
  height: 100px;
  top: 100px;
  right: 15%;
}

.shape-6 {
  width: 80px;
  height: 80px;
  bottom: 200px;
  left: 10%;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 返回按钮样式 */
.back-btn {
  position: fixed;
  top: 20px;
  left: 20px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #6a1b9a;
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: #fff;
  color: #7b1fa2;
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

@media (max-width: 900px) {
  .auth-container {
    width: 100%;
    max-width: 450px;
    height: auto;
    min-height: 600px;
  }

  .form-panel {
    position: relative;
    width: 100%;
    height: auto;
    padding: 30px 25px;
  }

  .login-panel {
    left: 0;
  }

  .login-panel.form-right {
    left: 0;
    display: none;
  }

  .register-panel {
    right: 0;
  }

  .register-panel.form-left {
    right: 0;
    display: none;
  }

  .overlay-card {
    position: relative;
    width: 100%;
    height: 180px;
    clip-path: none;
    border-radius: 0;
  }

  .overlay-card.card-right,
  .overlay-card.card-left {
    left: 0;
    right: 0;
    border-radius: 0;
  }

  .overlay-content {
    transform: translateX(0);
  }

  .overlay-logo {
    width: 70px;
    height: 70px;
    margin-bottom: 15px;
  }

  .overlay-title {
    font-size: 22px;
  }

  .overlay-subtitle {
    font-size: 13px;
    margin-bottom: 20px;
  }

  .overlay-btn {
    padding: 10px 28px;
    font-size: 13px;
  }
}
</style>
